import { render, staticRenderFns } from "./PaperAnswers.vue?vue&type=template&id=8e93529e&scoped=true"
import script from "./PaperAnswers.vue?vue&type=script&lang=js"
export * from "./PaperAnswers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e93529e",
  null
  
)

export default component.exports